/**
 * 用户行为跟踪事件类型定义
 */

/**
 * 事件名称枚举
 */
export enum TrackingEvent {
  /** Tab 切换事件 */
  TAB_CLICK = 'tab_click',
  /** 侧边栏点击事件 */
  SIDEBAR_CLICK = 'sidebar_click',
  /** 返回按钮点击事件 */
  BACK_CLICK = 'back_click',
  /** 语言切换事件 */
  LANG_SWITCH = 'lang_switch',
  /** 访问定价页面事件 */
  VISIT_PRICE = 'visit_price',
  /** 访问支付页面事件 */
  VISIT_CHECKOUT = 'visit_checkout',
}

/**
 * Tab 名称枚举
 */
export enum TabName {
  /** 总结 Tab */
  SUMMARY = 'summary',
  /** 转录 Tab */
  TRANSCRIPT = 'transcript',
  /** 翻译 Tab */
  TRANSLATION = 'translation',
}

/**
 * 菜单项名称枚举
 */
export enum MenuItem {
  /** 历史记录 */
  HISTORY = 'history',
  /** 识别词库 */
  RECOG_DICT = 'recog_dict',
  /** 翻译词库 */
  TRANS_DICT = 'trans_dict',
}

/**
 * Tab 切换事件参数
 */
export interface TabClickParams {
  tab_name: TabName;
}

/**
 * 侧边栏点击事件参数
 */
export interface SidebarClickParams {
  menu_item: MenuItem;
}

/**
 * 返回按钮点击事件参数（无额外参数）
 */
export type BackClickParams = Record<string, never>;

/**
 * 语言切换事件参数
 */
export interface LangSwitchParams {
  /** 目标语言代码，如 'zh-CN', 'en', 'ja' */
  lang_target: string;
}

/**
 * 访问定价页面事件参数（无额外参数）
 */
export type VisitPriceParams = Record<string, never>;

/**
 * 访问支付页面事件参数（无额外参数）
 */
export type VisitCheckoutParams = Record<string, never>;

/**
 * 所有事件参数的联合类型
 */
export type TrackingParams =
  | TabClickParams
  | SidebarClickParams
  | BackClickParams
  | LangSwitchParams
  | VisitPriceParams
  | VisitCheckoutParams;
